import type { IWishlistService } from '../services/wishlistService';
import type { IDirective, IParseService } from 'angular';
import type { OfferIdType } from '../wishlist.module';

angular.module('wishlist').directive('wishlistControl', [
    'wishlistService',
    '$parse',
    (wishlistService: IWishlistService, $parse: IParseService): IDirective => ({
        restrict: 'A',
        scope: true,
        controller: 'WishlistControlCtrl',
        controllerAs: 'wishlistControl',
        bindToController: true,
        link(scope, _element, attrs, ctrl) {
            if (attrs.wishlistControl !== null && ctrl) {
                const offerId: number = $parse(attrs.wishlistControl)(scope);
                ctrl.offerId = offerId;

                scope.$watch(attrs.wishlistControl, (newValue, oldValue) => {
                    if (newValue === oldValue) return;
                    ctrl.checkStatus(newValue as OfferIdType);
                });

                scope.$on('$destroy', () => {
                    wishlistService.removeWishlistScope(offerId, ctrl);
                });

                if (ctrl.offerId !== null) {
                    wishlistService.addWishlistScope(offerId, ctrl);
                }
            }
        },
    }),
]);

angular.module('wishlist').directive(
    'wishlistCount',
    (): IDirective => ({
        restrict: 'A',
        scope: true,
        controller: 'WishlistCountCtrl',
        controllerAs: 'wishlistCount',
        bindToController: true,
        link(_scope, _element, attrs, ctrl) {
            if (ctrl) {
                ctrl.countObj.count = parseInt(attrs.startCount, 10);
            }
        },
    }),
);

angular.module('wishlist').directive('wishlistWrapper', [
    'wishlistService',
    'domService',
    (wishlistService: IWishlistService, domService): IDirective => ({
        restrict: 'A',
        scope: true,
        link(scope, element, attrs) {
            const wrapper = element[0];
            const itemSelector = attrs.wishlistWrapper;

            const createRemoveBtn = (): HTMLAnchorElement => {
                const btn = document.createElement('a');
                // eslint-disable-next-line no-script-url
                btn.href = 'javascript:void(0);';
                btn.setAttribute('role', 'link');
                btn.className = 'js-wishlist-remove wishlist-remove icon-cancel-circled-before link-text-decoration-none cs-l-5';
                return btn;
            };

            const ensureRemoveButtons = () => {
                wrapper.querySelectorAll<HTMLElement>(itemSelector).forEach((item) => {
                    if (!item.querySelector('.js-wishlist-remove')) {
                        item.appendChild(createRemoveBtn());
                    }
                });
            };

            ensureRemoveButtons();

            // Re-append buttons when Vue re-renders and replaces item nodes.
            // Helper изолирует `matches` от потока — его type-predicate
            // перегрузки в TS 6 сужают `el` до `never` после if/||.
            const elementMatches = (el: Element, selector: string): boolean => el.matches(selector);
            const isOrContainsItem = (node: Node): boolean => {
                if (node.nodeType !== Node.ELEMENT_NODE) return false;
                const el = node as Element;
                return elementMatches(el, itemSelector) || el.querySelector(itemSelector) !== null;
            };
            const observer = new MutationObserver((mutations) => {
                const hasNewItems = mutations.some((mutation) => {
                    for (const node of mutation.addedNodes) {
                        if (isOrContainsItem(node)) return true;
                    }
                    return false;
                });
                if (hasNewItems) ensureRemoveButtons();
            });
            observer.observe(wrapper, { childList: true, subtree: true });

            // Event delegation on the stable wrapper — survives Vue re-renders of inner items
            wrapper.addEventListener('click', (event: Event) => {
                const target = event.target as Element;

                if (target.classList.contains('js-wishlist-remove')) {
                    const item = target.closest<HTMLElement>(itemSelector);
                    if (!item) return;
                    const offerId = Number(item.getAttribute('data-offer-id'));
                    if (!Number.isNaN(offerId)) {
                        wishlistService.remove(offerId).then(() => {
                            const blockForDelete = domService.closest(item, '.js-products-view-block');
                            if (blockForDelete?.parentNode) {
                                blockForDelete.parentNode.removeChild(blockForDelete);
                            }
                        });
                    }
                } else {
                    const wishlistControlBtn = target.closest('.wishlist-control');
                    if (wishlistControlBtn) {
                        const item = wishlistControlBtn.closest<HTMLElement>(itemSelector);
                        if (!item) return;
                        const offerId = Number(item.getAttribute('data-offer-id'));
                        if (!Number.isNaN(offerId)) {
                            wishlistService.remove(offerId).then(() => {
                                const blockForDel = domService.closest(item, '.js-products-view-block');
                                if (blockForDel?.parentNode) {
                                    blockForDel.parentNode.removeChild(blockForDel);
                                }
                            });
                        }
                    }
                }
            });

            scope.$on('$destroy', () => {
                observer.disconnect();
            });
        },
    }),
]);
